import { render } from "./packageManagementXuser.vue?vue&type=template&id=4563fb4e&scoped=true"
import script from "./packageManagementXuser.vue?vue&type=script&lang=js"
export * from "./packageManagementXuser.vue?vue&type=script&lang=js"

import "./packageManagementXuser.vue?vue&type=style&index=0&id=4563fb4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4563fb4e"

export default script